module.exports = __webpack_public_path__ + "img/27.13aa1c60.jpg";